// NOTE: you must pass the published communityId in for this to work - draft ids will not work
export const getAdminNotesByCommunityId = (approvedCommunityId) => (state) => {
  return state.adminNotes.communities['' + approvedCommunityId]; // note must convert id to string to have lookup always work
};
